export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/mdi_location.521c55bc.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};